import {
  type CompositionV2Filters,
  PositionsEntityKind,
} from '@revelio/data-access';

export function getSegmentEntityType({
  secondaryDimension,
  compositionFilters,
}: {
  secondaryDimension: 'geography' | 'role';
  compositionFilters: CompositionV2Filters;
}): PositionsEntityKind | null {
  if (secondaryDimension === 'geography') {
    if (compositionFilters.region?.length) {
      return PositionsEntityKind.Country;
    }
    if (compositionFilters.country?.length) {
      return PositionsEntityKind.Msa;
    }
    if (compositionFilters.msa?.length) {
      return PositionsEntityKind.City;
    }
    if (compositionFilters.city?.length) {
      return PositionsEntityKind.City;
    }

    return PositionsEntityKind.Region;
  }

  if (secondaryDimension === 'role') {
    const roleEntities = compositionFilters.custom_role?.entities;
    if (!roleEntities || roleEntities.length === 0) {
      return PositionsEntityKind.RoleK7;
    }
    const levelId = roleEntities[0]?.levelId;
    if (!levelId) return PositionsEntityKind.RoleK7;
    if (levelId === 'role_k7') return PositionsEntityKind.RoleK150;
    if (levelId === 'role_k150') return PositionsEntityKind.RoleK1500;
    if (levelId === 'role_k1500') return PositionsEntityKind.RoleK15000;
    if (levelId === 'role_k15000') return PositionsEntityKind.RoleK15000;
    return PositionsEntityKind.RoleK7;
  }

  return null;
}
